<ham-modal
    [title]="'aumico_topal_connect_modal_title' | i18next"
    [hideFooter]="true"
    [size]="'sm'"
    (cancel)="onCancel()"
>
    <div class="topal-modal-body">
        <!-- Step 1: form -->
        <section *ngIf="step === 'welcome'">
            <p class="topal-modal-body__paragraph">
                {{ 'aumico_topal_step_welcome_intro' | i18next }}
            </p>

            <div class="topal-modal-body__field">
                <label for="topalDisplayName">
                    {{ 'aumico_integration_setup_displayname_label' | i18next }}
                </label>
                <input
                    hamInput
                    id="topalDisplayName"
                    type="text"
                    [(ngModel)]="displayName"
                    [placeholder]="'aumico_integration_setup_displayname_placeholder' | i18next"
                />
                <small class="topal-modal-body__hint">
                    {{ 'aumico_topal_step_config_displayname_help' | i18next }}
                </small>
            </div>

            <div class="topal-modal-body__field">
                <label for="topalServerUrl">
                    {{ 'aumico_topal_step_config_serverurl_label' | i18next }}
                </label>
                <input
                    hamInput
                    id="topalServerUrl"
                    type="url"
                    [(ngModel)]="serverUrl"
                    placeholder="https://topal.example.ch:9001"
                />
                <small class="topal-modal-body__hint">
                    {{ 'aumico_topal_step_config_serverurl_help' | i18next }}
                </small>
            </div>

            <div class="topal-modal-body__field">
                <label for="topalUsername">
                    {{ 'aumico_topal_step_config_username_label' | i18next }}
                </label>
                <input
                    hamInput
                    id="topalUsername"
                    type="text"
                    [(ngModel)]="username"
                    autocomplete="off"
                />
            </div>

            <div class="topal-modal-body__field">
                <label for="topalPassword">
                    {{ 'aumico_topal_step_config_password_label' | i18next }}
                </label>
                <!--
                    NOT a `type="password"` input on purpose: Chrome auto-offers to save
                    credentials whenever a real password field had a value and its DOM is
                    then replaced (which happens after submit, when we swap in the testing
                    step). We keep `type=text` always and mask visually via
                    `-webkit-text-security: disc` when `showPassword` is false (see the
                    .scss). The show/hide toggle just flips the masked class.
                -->
                <input
                    hamInput
                    id="topalPassword"
                    type="text"
                    [class.topal-modal-body__secret-masked]="!showPassword"
                    [(ngModel)]="password"
                    autocomplete="off"
                    spellcheck="false"
                    data-lpignore="true"
                />
                <div class="topal-modal-body__hint-row">
                    <small class="topal-modal-body__hint">
                        {{ 'aumico_topal_step_config_password_help' | i18next }}
                    </small>
                    <button
                        type="button"
                        class="topal-modal-body__toggle"
                        (click)="onTogglePassword()"
                    >
                        {{
                            showPassword
                                ? ('aumico_topal_step_config_password_hide' | i18next)
                                : ('aumico_topal_step_config_password_show' | i18next)
                        }}
                    </button>
                </div>
            </div>

            <div class="topal-modal-body__actions">
                <ham-button
                    variant="primary"
                    size="sm"
                    [disabled]="!isFormValid"
                    (buttonClick)="onSubmit()"
                >
                    {{ 'aumico_integration_connect_button' | i18next }}
                </ham-button>
                <ham-button variant="primary" size="sm" [outline]="true" (buttonClick)="onCancel()">
                    {{ 'aumico_button_cancel' | i18next }}
                </ham-button>
            </div>
        </section>

        <!-- Step 2: BE testing the credentials -->
        <section *ngIf="step === 'testing'" class="topal-modal-body__loading">
            <div class="topal-modal-body__spinner"></div>
            <p class="topal-modal-body__paragraph">
                {{ 'aumico_integration_status_testing' | i18next }}
            </p>
            <ham-button variant="primary" size="sm" [outline]="true" (buttonClick)="onCancel()">
                {{ 'aumico_button_cancel' | i18next }}
            </ham-button>
        </section>

        <!-- Step 3: error from token / smoke test -->
        <section *ngIf="step === 'error'" class="topal-modal-body__error">
            <div class="topal-modal-body__error-icon">⚠</div>
            <h3 class="topal-modal-body__title">{{ 'aumico_integration_status_error_title' | i18next }}</h3>
            <p class="topal-modal-body__error-message">{{ errorMessage }}</p>
            <div class="topal-modal-body__actions">
                <ham-button variant="primary" size="sm" (buttonClick)="onRetryFromError()">
                    {{ 'aumico_button_retry' | i18next }}
                </ham-button>
                <ham-button variant="primary" size="sm" [outline]="true" (buttonClick)="onCancel()">
                    {{ 'aumico_button_cancel' | i18next }}
                </ham-button>
            </div>
        </section>
    </div>
</ham-modal>
